@if (platforms.length !== allPlatforms.length) {
  @for (platform of platforms; track platform) {
    <span
      [ngClass]="platform"
      [attr.data-testid]="'platform-item-' + platform"
      >
      {{ platform }}
    </span>
  }
}
